import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export const addMessage = async (userId, token, message, linkitysId = null) => {
  try {
    const response = await makeCSRFRequest(`${BASE_URL}/vieraskirja/post`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
      body: JSON.stringify({
        nimi_id: userId,
        viesti: message,
        linkitys: linkitysId,
      }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.banned) {
        alert("OLET ARESTISSA");
        window.location.reload();
        return { error: "banned" };
      }
      throw new Error(errorData.error || "Viestin lähetys epäonnistui");
    }

    return await response.json();
  } catch (error) {
    console.error(error);
  }
};
